export enum AiAttachmentMimeType {
  Jpeg = 'image/jpeg',
  Png = 'image/png',
  Xls = 'application/vnd.ms-excel',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Csv = 'text/csv',
}

export const kAiAttachmentMaxFileBytes = 20 * 1024 * 1024;

export function isAiAttachmentId(value: unknown): value is string {
  return (
    typeof value === 'string' && /^aia_[0-9a-hjkmnp-tv-z]{26}$/.test(value)
  );
}

export interface AiAttachmentInfo {
  id: string;
  fileName: string;
  mimeType: AiAttachmentMimeType;
  sizeBytes: number;
  sha256: string;
}
